import { List, fromJS } from 'immutable'
import { PAGE_ROLE_MAPPING } from '../roles'

export const SET_AUTH_PROCESSING = 'SET_AUTH_PROCESSING'
export const SET_AUTH_LOGIN = 'SET_AUTH_LOGIN'
export const SET_AUTH_DATA = 'SET_AUTH_DATA'
export const GET_AUTH_LOGIN = 'GET_AUTH_LOGIN'
export const GET_AUTH_LOGOUT = 'GET_AUTH_LOGOUT'
export const SET_AUTH_LOGIN_ERROR = 'SET_AUTH_LOGIN_ERROR'
export const GET_AUTH_RENEW = 'GET_AUTH_RENEW'
export const GET_AUTH_DATA_LOCAL = 'GET_AUTH_DATA_LOCAL'

/**
 * - This function adds a property onto auth data outlining all admin app pages
 *   the user is entitled to access
 * @param {object} data Data returned from auth service
 */
function _addPageEntitlementsToAuthData (data) {
  let pageEntitlements = List()
  if (!data.get('success')) return data

  // using Immutable Set<T> here so we have access to Set.intersect()
  const userRolesSet = data.get('roleIds').toSet()

  fromJS(PAGE_ROLE_MAPPING).forEach((pageRoles, pageKey) => {
    const pageRolesSet = pageRoles.toSet()
    // see if the user has any of the required roles to access the current page key
    const intersection = pageRolesSet.intersect(userRolesSet)
    if (intersection.size > 0) {
      pageEntitlements = pageEntitlements.push(pageKey)
    }
  })
  return data.set('pageEntitlements', pageEntitlements)
}

export function setAuthProcessing (processing = true) {
  return {
    type: SET_AUTH_PROCESSING,
    payload: processing,
  }
}

export function setAuthLogin ({ data, processing = true }) {
  return {
    type: SET_AUTH_LOGIN,
    payload: { data, processing },
  }
}

export function getAuthLogout () {
  return {
    type: GET_AUTH_LOGOUT,
  }
}

export function setAuthData ({ data, processing = true }) {
  const dataWithPageEntitlements = _addPageEntitlementsToAuthData(data)
  return {
    type: SET_AUTH_DATA,
    payload: { data: dataWithPageEntitlements, processing },
  }
}

export function getAuthLogin ({ username, password }) {
  return {
    type: GET_AUTH_LOGIN,
    payload: { username, password },
  }
}

export function setAuthLoginError (error) {
  return {
    type: SET_AUTH_LOGIN_ERROR,
    payload: error,
  }
}

export function getAuthRenew () {
  return {
    type: GET_AUTH_RENEW,
  }
}

export function getAuthDataLocal () {
  return {
    type: GET_AUTH_DATA_LOCAL,
  }
}
